module.exports = __webpack_public_path__ + "img/UnityFrameworkFPSBehaviour.dd2ba697.gif";